import { z } from "zod";

export const DamageTypeSchema = z.enum([
  "slashing",
  "piercing",
  "bludgeoning",
  "fire",
  "cold",
  "lightning",
  "thunder",
  "poison",
  "acid",
  "necrotic",
  "radiant",
  "force",
  "psychic",
]);
export type DamageType = z.infer<typeof DamageTypeSchema>;

export const DamageComponentSchema = z.object({
  formula: z.string(),
  type: DamageTypeSchema,
  amount: z.number(),
});
export type DamageComponent = z.infer<typeof DamageComponentSchema>;
